export default "__VITE_ASSET__Bxv1krJv__"